__turbopack_context__.v({
  "caption": "SleepFeatureCards-module__ExBtWG__caption",
  "card": "SleepFeatureCards-module__ExBtWG__card",
  "cardImage": "SleepFeatureCards-module__ExBtWG__cardImage",
  "cardOverlay": "SleepFeatureCards-module__ExBtWG__cardOverlay",
  "cardsContainer": "SleepFeatureCards-module__ExBtWG__cardsContainer",
  "contentContainer": "SleepFeatureCards-module__ExBtWG__contentContainer",
  "description": "SleepFeatureCards-module__ExBtWG__description",
  "mobileCaption": "SleepFeatureCards-module__ExBtWG__mobileCaption",
  "mobileCarouselContainer": "SleepFeatureCards-module__ExBtWG__mobileCarouselContainer",
  "mobileCarouselWrapper": "SleepFeatureCards-module__ExBtWG__mobileCarouselWrapper",
  "mobileEmbla": "SleepFeatureCards-module__ExBtWG__mobileEmbla",
  "mobileEmblaContainer": "SleepFeatureCards-module__ExBtWG__mobileEmblaContainer",
  "mobileEmblaSlide": "SleepFeatureCards-module__ExBtWG__mobileEmblaSlide",
  "mobileImage": "SleepFeatureCards-module__ExBtWG__mobileImage",
  "mobileImageWrapper": "SleepFeatureCards-module__ExBtWG__mobileImageWrapper",
  "mobileSubtitle": "SleepFeatureCards-module__ExBtWG__mobileSubtitle",
  "mobileTextContainer": "SleepFeatureCards-module__ExBtWG__mobileTextContainer",
  "mobileTextWrapper": "SleepFeatureCards-module__ExBtWG__mobileTextWrapper",
  "mobileTitle": "SleepFeatureCards-module__ExBtWG__mobileTitle",
  "sleepFeatureCardsSection": "SleepFeatureCards-module__ExBtWG__sleepFeatureCardsSection",
  "stickyContainer": "SleepFeatureCards-module__ExBtWG__stickyContainer",
  "stickyWrapper": "SleepFeatureCards-module__ExBtWG__stickyWrapper",
  "textContainer": "SleepFeatureCards-module__ExBtWG__textContainer",
  "textWrapper": "SleepFeatureCards-module__ExBtWG__textWrapper",
  "title": "SleepFeatureCards-module__ExBtWG__title",
  "whiteOverlay": "SleepFeatureCards-module__ExBtWG__whiteOverlay",
});
